import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import sortBy from 'lodash/sortBy'
import filter from 'lodash/filter'
import { adminSearchUsers } from '../../actions/admin'

import UserSearch from '../user/UserSearch'

import { adminFetchUsers, adminSetUserAdmin, adminSetUserConfirmed } from "../../actions/admin"
import { setTitle } from "../../actions/index"

import AdminUserRow from './AdminUserRow'

//import styles
import './styles/AdminUsers.scss';

import loaderImg from '../practice_admin/images/loader.gif'

@connect((store) => {
	return {
		users: store.users,
		User: store.User.User
	}
})
class AdminUsers extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			value: 'name',
			status: 'all',
			loading: true
		};
		this.statusChange = this.statusChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.toggleAdmin = this.toggleAdmin.bind(this);
		this.toggleConfirmed = this.toggleConfirmed.bind(this);
		this.searchUsers = this.searchUsers.bind(this)
		this.filterUsers = this.filterUsers.bind(this)
		this.setup = this.setup.bind(this)
	}
	
	componentWillMount() {
		this.props.dispatch(setTitle('Admin: users'));
		this.setup();
	}

	componentDidUpdate(nextProps) {
		if (this.props.User.token && this.props.User.name != nextProps.User.name) {
			this.setup();
		}
	}

	setup() {
		if (this.props.User.token && this.props.User.name != '') {
			console.log('Fetch users.');
			this.props.dispatch(adminFetchUsers())
			.then(users => {
				console.log('Loaded users.');
				this.setState({
					loading: false
				});
			});
		}
	}

	handleChange(event) {
		this.setState({ value: event.target.value });
	}

	statusChange(event) {
		this.setState({ status: event.target.value });
	}

	searchUsers(s) {
		const { dispatch } = this.props
		// this.setState({
		// 	loading: true
		// });
		if (!s || s === '') {
			return dispatch(adminFetchUsers())
			.then(users => {
				this.setState({
					'loading': false
				});
			});
		}
		dispatch(adminSearchUsers(s))
		.then(users => {
			this.setState({
				'loading': false
			});
		});
	}

	toggleAdmin(user) {
		this.props.dispatch(adminSetUserAdmin(user.uid));
	}

	toggleConfirmed(user) {
		this.props.dispatch(adminSetUserConfirmed(user.uid));
	}

	filterUsers() {
		let { status } = this.state;
		let users = this.props.users;
		let filteredUsers = [];
		
		if (status === 'owner') {
			users.forEach(function (element) {
				if (element.owner) {
					filteredUsers.push(element);
				}
			});
		} else if (status === 'parent') {
			users.forEach(function (element) {
				if (element.parent) {
					filteredUsers.push(element);
				}
			});
		} else if (status === 'therapist') {
			users.forEach(function (element) {
				if (element.therapist) {
					filteredUsers.push(element);
				}
			});
		} else if (status === 'unassigned') {
			users.forEach(function (element) {
				// console.log(element);
				if (((element.ownPractices === undefined) || (element.ownPractices.length < 1))
				&& ((element.practices === undefined) || (element.practices.length < 1))
				&& ((element.therapistPractices === undefined) || (element.therapistPractices.length < 1))) {
					filteredUsers.push(element);
				}
			});
		} else {
			return users;
		}
		return filteredUsers.length > 0 ? filteredUsers: users;
	}

	render() {
		let {
			loading
		} = this.state;

		if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};
			
			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt=""/>
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

		return (
			<main className="main page usersView">
				<div className="adminUsers mb8">
					<UserSearch onSearch={this.searchUsers} />

					<div className="filterRow">
						Filter By:<select value={this.state.status} onChange={this.statusChange}>
							<option value="all">All</option>
							<option value="owner">Owner</option>
							<option value="parent">Parent</option>
							<option value="therapist">Therapist</option>
							<option value="unassigned">Unassigned</option>
						</select>

						Sort By:<select value={this.state.value} onChange={this.handleChange}>
							<option value="">All</option>
							<option value="name">Name</option>
							<option value="created">Date</option>
						</select>
					</div>

					<ul className="md-list wide">
						{
							sortBy(this.filterUsers(), [this.state.value]).map((user, i) => user.uid && (
							<AdminUserRow key={`user-${user._id}`} handleToggleAdmin={this.toggleAdmin}
								user={user}></AdminUserRow>
						))}
					</ul>
				</div>
			</main>
		)
	}
}

class ChildOption extends React.Component {
	propTypes: {
		name: React.PropTypes.string,
		value: React.PropTypes.string,
	};

	render() {
		return (
			<option value={this.props.value}>{this.props.name}</option>
		)
	}
}

export default withRouter(AdminUsers);



// WEBPACK FOOTER //
// ./src/components/admin/AdminUsers.jsx